export default {
  heroTitle: '海量番号，一搜即达',
  heroSubtitle: '番号本为您提供最全面的番号数据库检索服务，涵盖全新番号、热门排行、经典回顾等多种分类，操作简便，数据精准，更新及时。',
  heroPlaceholder: '输入番号编号或关键词搜索...',
  heroSearchBtn: '搜索番号',
  sectionCategories: '分类浏览',
  sectionCategoriesDesc: '按分类快速找到您感兴趣的番号内容',
  sectionLatest: '最新文章',
  sectionLatestDesc: '番号查询与收录的最新资讯和深度解读',
  sectionStats: '平台数据',
  sectionStatsDesc: '番号本持续为您提供最全面的番号数据服务',
  sectionCTA: '开始使用番号本',
  sectionCTADesc: '立即加入番号本，体验最专业的番号查询与收录服务。海量数据、精准搜索、及时更新，满足您的所有番号查询需求。',
  btnCTA: '立即探索',
  statArticles: '篇文章',
  categoryCount: '个番号',
  tagNew: '全新',
  tagHot: '热门',
  tagClassic: '经典',
};